import React from "react";
import Cards from "../Components/Cards";
import Home from "./Home";

function Products() {
  return (
    <div className="products">
      <Home/>
    </div>
  );
}

export default Products;
